import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <Container>
        <Row className="align-items-center py-4 gy-3">
          <Col md={6}>
            <div className="footer-brand">
              <h5 className="mb-1">League Runner</h5>
              <p className="footer-tagline mb-0">Trail-ready competition for modern running leagues.</p>
            </div>
          </Col>
          <Col md={6}>
            <div className="footer-links text-md-end">
              <Link to="/news" className="footer-link">News</Link>
              <span className="footer-separator">/</span>
              <Link to="/about" className="footer-link">About</Link>
              <span className="footer-separator">/</span>
              <Link to="/contact" className="footer-link">Contact</Link>
              <span className="footer-separator">/</span>
              <Link to="/privacy" className="footer-link">Privacy</Link>
              <span className="footer-separator">/</span>
              <Link to="/terms" className="footer-link">Terms</Link>
            </div>
            <div className="footer-copyright text-md-end mt-2">
              <small>&copy; {currentYear} League Runner. All rights reserved.</small>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
